import { render, staticRenderFns } from "./landingDetails.vue?vue&type=template&id=5a25b23c&"
import script from "./landingDetails.vue?vue&type=script&lang=js&"
export * from "./landingDetails.vue?vue&type=script&lang=js&"
import style0 from "./landingDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports